export type Language = 'zh' | 'en' | 'ru';

const STORAGE_KEY = 'ai-voice-language';

const EN: Record<string, string> = {
  '免费活动': 'Free promotion',
  '免费激活码活动': 'Free activation code promotion',
  '进行中': 'Active',
  '未开始': 'Not started',
  '已关闭': 'Closed',
  '开始日期': 'Start date',
  '结束日期': 'End date',
  '保存活动时间': 'Save promotion dates',
  '关闭免费活动': 'Disable free promotion',
  '开启免费活动': 'Enable free promotion',
  '免费活动时间已保存': 'Free promotion dates saved',
  '免费活动已开启': 'Free promotion enabled',
  '免费活动已关闭': 'Free promotion disabled',
  '开始日和结束日均按北京时间计算。每台设备每天可领取一次，不限制IP；关闭活动或日期不可用时隐藏领取入口，但已领取且未过期的免费码仍可使用。': 'Both dates use Beijing time. Each device can claim once per day with no IP restriction. When the promotion is unavailable, the claim entry is hidden, but unexpired codes already claimed remain available.',
  '活动时间：{range}': 'Promotion period: {range}',
  '今日已领取，{time} 后可再次领取': 'Claimed today. You can claim again in {time}.',
  '今日已领取，明天可再次领取': 'Claimed today. Try again tomorrow.',
  '活动尚未开始': 'The promotion has not started yet.',
  '免费活动当前不可用': 'The free promotion is currently unavailable.',
  '再领取一张 3 天激活码': 'Claim another 3-day activation code',
  '免费领取 3 天激活码': 'Claim a free 3-day activation code',
  '收费设置': 'Billing settings',
  '激活码价格与收费模式': 'Activation code pricing and paid mode',
  '收费模式已开启': 'Paid mode is on',
  '收费模式已关闭': 'Paid mode is off',
  '日卡价格': '1-day price',
  '周卡价格': '1-week price',
  '月卡价格': '1-month price',
  '保存价格': 'Save prices',
  '关闭收费模式': 'Disable paid mode',
  '开启收费模式': 'Enable paid mode',
  '激活码价格已保存': 'Activation code prices saved',
  '关闭收费模式后，听众端会隐藏付费购买区域，但已有订单仍可继续支付并自动发码；免费领取不受影响。价格仅支持 1–1,000,000 的整数 USDT，修改只影响新订单。': 'When paid mode is off, the listener purchase area is hidden, but existing orders can still be paid and receive codes automatically. Free claims are unaffected. Prices must be whole USDT values from 1 to 1,000,000, and changes affect new orders only.',
  '足球播报语音室': 'Football Audio Room',
  '当前入口': 'Current access',
  '主控台': 'Owner Console',
  '腾讯云 TRTC · 中国大陆': 'Tencent TRTC · Mainland China',
  '每个激活码最多绑定 3 台设备，同一时间仅限 1 台在线。': 'Each activation code supports up to 3 devices, with only 1 online at a time.',
  '请截图保存激活码，遗失不补': 'Save your activation code. It cannot be recovered if lost.',
  '语言': 'Language',
  '中文': 'Chinese',
  'English': 'English',
  'Русский': 'Russian',
  '正在检查管理服务...': 'Checking the management service...',
  '一次性初始化': 'One-time setup',
  '保存你的双重验证信息': 'Save your two-factor authentication details',
  '下面的二维码和恢复码只显示这一次。恢复码建议打印或保存在密码管理器中。': 'The QR code and recovery codes are shown only once. Print them or store them in a password manager.',
  '恢复码': 'Recovery codes',
  '我已安全保存，进入主控台': 'I saved them securely - enter Owner Console',
  '把电脑里的声音，安全地交给指定的人听。': 'Share your computer audio safely with selected listeners.',
  '浏览器直接共享系统声音。每张激活码最多绑定 3 台设备，同一时间只允许 1 台在线，有效期由主控设置。': 'Share system audio directly from the browser. Each activation code supports up to 3 devices, with only 1 online at a time and an owner-defined validity period.',
  '系统声音': 'System audio',
  '三设备上限': '3-device limit',
  '单设备在线': '1 online device',
  '完整审计': 'Full audit',
  '主控登录': 'Owner login',
  '管理员身份验证': 'Administrator authentication',
  '管理员账号': 'Administrator account',
  '强密码': 'Strong password',
  '动态码或恢复码': 'TOTP or recovery code',
  '6 位动态码': '6-digit TOTP',
  '验证中...': 'Verifying...',
  '登录主控台': 'Sign in to Owner Console',
  '首次部署': 'First deployment',
  '创建唯一管理员': 'Create the only administrator',
  '系统尚未初始化。': 'The system has not been initialized.',
  '开始初始化': 'Start setup',
  '部署引导令牌': 'Deployment bootstrap token',
  '强密码（至少 12 位）': 'Strong password (at least 12 characters)',
  '创建中...': 'Creating...',
  '创建管理员': 'Create administrator',
  '共享控制中心': 'Share Control Center',
  '房间': 'Room',
  '尚未开始': 'Not started',
  '正在共享': 'Sharing',
  '未共享': 'Not sharing',
  '刷新': 'Refresh',
  '退出登录': 'Sign out',
  '在线听众': 'Online listeners',
  '连接状态': 'Connection',
  '本月参与者分钟': 'Participant minutes this month',
  '未使用激活码': 'Unused activation codes',
  '正在向听众发布': 'Publishing to listeners',
  '准备共享电脑声音': 'Ready to share computer audio',
  '点击开始后，请在共享选择器中选择“整个屏幕”，并勾选“分享系统音频”。YY 语音、腾讯会议等软件声音会一起发送，其他系统声音也会包含在内。': 'After starting, choose “Entire screen” and enable “Share system audio”. Audio from YY, Tencent Meeting, and other system sounds will also be included.',
  'EXE 中将打开网页版主控页面，请在外部浏览器中选择一个或多个 Chrome/Edge 标签页；电脑系统音频请在 EXE 中直接使用。': 'The EXE opens the web Owner Console. Select one or more Chrome/Edge tabs in the external browser; use desktop system audio directly in the EXE.',
  '点击开始后，请在共享选择器中选择一个正在播放声音的 Chrome/Edge 标签页，并勾选“分享标签页音频”。': 'After starting, select a Chrome/Edge tab playing audio and enable “Share tab audio”.',
  '共享音频来源': 'Audio source',
  '电脑系统音频': 'Computer system audio',
  '共享电脑全部播放声音，包含 YY 语音、腾讯会议等软件。': 'Share all computer audio, including YY, Tencent Meeting, and other applications.',
  'Chrome 标签页音频': 'Chrome tab audio',
  '只共享你在选择器中指定的 Chrome/Edge 标签页声音。': 'Share only the Chrome/Edge tab selected in the picker.',
  '本窗口直播比赛': 'Match for this window',
  '请选择比赛': 'Select a match',
  '当前浏览器不支持读取系统声音，请改用最新版 Chrome 或 Edge。': 'This browser cannot capture system audio. Use the latest Chrome or Edge.',
  '正在连接...': 'Connecting...',
  '开始共享': 'Start sharing',
  '正在添加...': 'Adding...',
  '添加另一个标签页直播': 'Add another tab stream',
  '已启动 {count} 场标签页直播。': '{count} tab stream(s) running.',
  '停止全部共享': 'Stop all sharing',
  'Chrome 标签页直播': 'Chrome tab stream',
  '标签页音频': 'Tab audio',
  '恢复中...': 'Restoring...',
  '重新选择标签页': 'Reselect tab',
  '停止本场': 'Stop this stream',
  '等待开始': 'Waiting to start',
  '电脑系统与软件声音以 48 kHz 立体声发送': 'Computer and application audio is sent in 48 kHz stereo',
  '所选 Chrome 标签页声音以 48 kHz 立体声发送': 'Selected Chrome tab audio is sent in 48 kHz stereo',
  '可连续生成': 'Generate multiple',
  '生成 6 位激活码': 'Generate 6-digit activation code',
  '有效': 'Active',
  '新激活码有效期': 'New activation code validity',
  '正在生成...': 'Generating...',
  '生成激活码': 'Generate activation code',
  '生成后立即可用。': 'Available immediately after generation.',
  '可提前生成；主控开始共享后，听众才能进入。': 'Can be generated in advance; listeners can enter after sharing starts.',
  '每个码只允许首个设备使用，旧码不会被新码自动吊销。': 'Each code supports up to 3 devices, and new codes do not revoke old codes.',
  '请先选择比赛。': 'Select a match first.',
  '已在网页版打开主控页面。标签页独立直播请在外部浏览器中完成，请勿关闭浏览器窗口。': 'The web Owner Console was opened. Complete tab streaming in the external browser and do not close its window.',
  '封禁原因': 'Ban reason',
  '管理员封禁': 'Banned by administrator',
  '请完整填写比赛时间、联赛、主队和客队': 'Complete the match time, league, home team, and away team.',
  '确定删除这场赛程吗？': 'Delete this fixture?',
  '赛程管理': 'Fixture management',
  '新增赛程': 'Add fixture',
  '比赛时间': 'Match time',
  '联赛': 'League',
  '主队': 'Home team',
  '客队': 'Away team',
  '保存赛程': 'Save fixture',
  '保存修改': 'Save changes',
  '取消编辑': 'Cancel editing',
  '编辑': 'Edit',
  '删除': 'Delete',
  '暂无赛程。': 'No fixtures yet.',
  '购买订单与异常付款': 'Purchase orders and abnormal payments',
  '暂无自助购买订单。': 'No self-service orders.',
  '异常到账 {count} 笔': '{count} abnormal payments',
  '激活码记录': 'Activation code records',
  '激活码管理': 'Activation code management',
  '有效激活码': 'Active activation codes',
  '过期与吊销记录自动隐藏': 'Expired and revoked codes are hidden automatically',
  '主控生成': 'Owner generated',
  '免费领取': 'Free claim',
  '搜索激活码、昵称或设备': 'Search code, nickname, or device',
  '未显示': 'Not shown',
  '当前分组没有有效激活码。': 'No active codes in this group.',
  '订单': 'Order',
  '复制': 'Copy',
  '最近激活码': 'Recent activation codes',
  '尚未使用': 'Unused',
  '设备': 'Devices',
  '当前': 'Current',
  '剩余': 'Remaining',
  '吊销': 'Revoke',
  '还没有生成激活码。': 'No activation codes generated yet.',
  '费用保护': 'Cost protection',
  '月度使用上限': 'Monthly usage limit',
  '参与者分钟': 'Participant minutes',
  '保存': 'Save',
  '默认 9,000 分钟，为腾讯云免费额度预留余量；设为 0 表示不限制。达到上限后新听众会被拒绝，已有听众不会被强制中断。': 'Default: 9,000 minutes with headroom for the Tencent Cloud free tier; 0 means unlimited. New listeners are rejected at the limit, while existing listeners continue.',
  '显示效果': 'Display settings',
  '虚拟在线人数': 'Virtual online count',
  '基础人数': 'Base count',
  '虚拟在线人数已保存': 'Virtual online count saved',
  '当前显示 {count} 人；保存后立即生效并保持到下一次 5–10 分钟更新；开播后按设定基数波动约 ±1；无直播且超过该窗口后恢复随机 5–10 人；真人加入或退出会同步 +1 / -1。该数字不影响真实听众上限。': 'Currently showing {count}. The saved value takes effect immediately and is held until the next 5–10 minute update. While live, it fluctuates around the configured base by about ±1. If no stream is active after that window, it returns to a random 5–10. Real listeners add or subtract 1. This does not affect the real listener limit.',
  '听众通知': 'Listener notice',
  '滚动字幕': 'Scrolling message',
  '输入要滚动显示的通知内容': 'Enter the notice to scroll on the listener page',
  '保存字幕': 'Save message',
  '清空': 'Clear',
  '滚动字幕已保存': 'Scrolling message saved',
  '滚动字幕已清空': 'Scrolling message cleared',
  '听众端登录前和进入语音室后都会在赛程卡下方显示。留空并保存即可隐藏。': 'Shown below the schedule card both before and after listeners enter the room. Save an empty message to hide it.',
  '安全': 'Security',
  '封禁设备': 'Banned devices',
  '隐藏审计日志': 'Hide audit log',
  '查看审计日志': 'View audit log',
  '解除封禁': 'Unban',
  '当前没有封禁设备。': 'No banned devices.',
  '已连接': 'Connected',
  '重连中': 'Reconnecting',
  '未连接': 'Disconnected',
  '网络不稳定': 'Unstable network',
  '恢复中': 'Restoring',
  '已暂停': 'Paused',
  '等待授权': 'Waiting for permission',
  '音频已就绪': 'Audio ready',
  '授权失败': 'Permission failed',
  '1 天': '1 day',
  '1 周': '1 week',
  '1 个月': '1 month',
  '{seconds} 秒': '{seconds} seconds',
  '待支付': 'Pending payment',
  '已支付': 'Paid',
  '已过期': 'Expired',
  '非指定 USDT': 'Unsupported USDT',
  '金额或订单不匹配': 'Amount or order mismatch',
  '不在付款时限': 'Outside payment window',
  '交易已处理': 'Transaction already processed',
  '已启用': 'Activated',
  '已吊销': 'Revoked',
  '匹配': 'Match',
  '常用': 'Frequent',
  '复制失败，请手动复制。': 'Copy failed. Please copy manually.',
  '自助购买': 'Self-service purchase',
  '购买激活码': 'Buy activation code',  '限时福利': 'Limited-time offer',
  '免费领取激活码': 'Claim a free activation code',
  '活动时间：9月1日–9月30日': 'Promotion: September 1–30',
  '免费领取 3 天激活码（9月1日–9月30日）': 'Claim a free 3-day activation code (September 1–30)',
  '免费激活码已领取': 'Free activation code claimed',
  '免费激活码领取成功': 'Free activation code claimed successfully',
  '正在领取...': 'Claiming...',
  '正在检查免费领取活动...': 'Checking the free-claim promotion...',
  '活动将于9月1日开始（9月1日–9月30日）': 'Promotion starts September 1 (September 1–30)',
  '免费领取已结束（9月1日–9月30日）': 'The free-claim promotion has ended (September 1–30)',
  '24小时内仅可领取一次（{time} 后可再次领取）': 'The network claim limit was reached; try again in {time}.',
  '该设备已经领取过免费激活码，无法再次领取': 'This device has already claimed the free activation code.',
  '该网络已领取过免费激活码，无法再次领取': 'A free activation code has already been claimed from this network.',
  '订单 {id}': 'Order {id}',
  '剩余 {time}': '{time} remaining',
  '订单已过期': 'Order expired',
  '请精确支付': 'Pay the exact amount',
  '复制金额': 'Copy amount',
  '收款地址': 'Receiving address',
  '复制地址': 'Copy address',
  '只通过 TRON 网络支付 TRC20 USDT，不要使用 ERC20、BEP20 或其他网络。金额必须完全一致，否则无法自动发码。': 'Pay TRC20 USDT only on the TRON network. Do not use ERC20, BEP20, or other networks. The amount must match exactly or the code cannot be issued automatically.',
  '重新生成订单': 'Regenerate order',
  '支付已确认': 'Payment confirmed',
  '有效期至 {time}': 'Valid until {time}',
  '复制激活码': 'Copy activation code',
  '填入并进入': 'Fill and enter',
  '应付金额已复制': 'Amount copied',
  '收款地址已复制': 'Address copied',
  '激活码已复制': 'Activation code copied',
  '听众入口': 'Listener entry',
  '请输入你的六位激活码': 'Enter your 6-digit activation code',
  '在线 {count} 人': '{count} online',
  '每张激活码最多绑定 3 台设备，同一时间仅限 1 台在线；关闭页面或主动退出后，可重新输入同一激活码继续收听。': 'Each activation code supports up to 3 devices, with only 1 online at a time. After closing the page or leaving, you can enter the same code again.',
  '你的昵称（必填）': 'Your nickname (required)',
  '例如：小王': 'For example: Alex',
  '六位激活码': '6-digit activation code',
  '进入语音室': 'Enter audio room',
  '正在进入语音室...': 'Entering the audio room...',
  '正在收听': 'Listening',
  '等待音源接入中': 'Waiting for audio source',
  '播放已暂停': 'Playback paused',
  '声音正在播放': 'Audio playing',
  '等待声音到来': 'Waiting for audio',
  '激活码剩余有效期': 'Activation code validity',
  '本机音量': 'Local volume',
  '播放设备': 'Output device',
  '默认播放设备': 'Default output device',
  '切换比赛': 'Switch match',
  '其他直播': 'Other stream',
  '（当前收听）': ' (currently listening)',
  '正在切换...': 'Switching...',
  '切换到此场': 'Switch to this match',
  '网络延迟': 'Network latency',
  '恢复窗口到': 'Recovery window until',
  '恢复播放': 'Resume playback',
  '暂停播放': 'Pause playback',
  '退出语音室': 'Leave audio room',
  '主控可以暂停播放、踢出或封禁设备。会话不会给予下载或录制权限。': 'The owner can pause playback, remove, or ban devices. Sessions never grant download or recording permissions.',
  '暂无赛程': 'No fixtures',
  '正在进行': 'Live',
  '下一场': 'Next',
  '下一场直播': 'Next live match',
  '近期赛程': 'Upcoming fixtures',
  '等待中': 'Waiting',
  '耐心等待，祝君好运！': 'Please wait patiently. Good luck!',
  '正在恢复上次收听...': 'Restoring your previous session...',
  '上次收听会话已结束。': 'The previous session has ended.',
  '上次收听会话已失效，请重新进入。': 'The previous session has expired. Please enter again.',
  '已恢复收听。': 'Listening restored.',
  '控制服务网络不稳定，正在自动重试...': 'The control service is unstable. Retrying automatically...',
  '激活码已过期，请重新购买或联系主控获取。': 'The activation code has expired. Buy a new one or contact the owner.',
  '连接多次恢复失败，请重新取得激活码。': 'Reconnection failed repeatedly. Obtain a new activation code.',
  '检测到临时中断，正在自动恢复...': 'Temporary interruption detected. Restoring automatically...',
  '已自动恢复收听。': 'Listening restored automatically.',
  '会话已结束，如需继续收听请向主控索取新的激活码。': 'The session has ended. Request a new activation code from the owner.',
  '音频连接波动，正在等待自动恢复...': 'The audio connection is unstable. Waiting to recover...',
  '你已被主控移出语音室。': 'You were removed from the audio room by the owner.',
  '主控已暂停你的播放。': 'The owner paused your playback.',
  '主控已恢复播放。': 'The owner resumed playback.',
  '连接中断，正在恢复...': 'Connection lost. Restoring...',
  '连接已恢复。': 'Connection restored.',
  '请填写昵称后再进入': 'Enter a nickname before continuing.',
  '已进入语音室。若浏览器没有自动播放，请点击“恢复播放”。': 'You entered the audio room. If audio does not start automatically, tap “Resume playback”.',
  '已在本机暂停播放。': 'Playback paused locally.',
  '已恢复播放。': 'Playback resumed.',
  '已切换到新的比赛。': 'Switched to the new match.',
  '切换失败，原房间也无法恢复，请重新进入语音室。': 'Switch failed and the original room could not be restored. Please enter again.',
  '切换比赛失败：{message}': 'Failed to switch match: {message}',
  '已退出语音室。': 'You left the audio room.',
  '{days}天 {clock}': '{days}d {clock}',
  '{label}有效 · 发给一位听众': '{label} active · Send to one listener',
  '{time}后失效 · 最多 3 台设备': 'Expires in {time} · Up to 3 devices',
  '状态：{status}': 'Status: {status}',
  '未使用激活码已达 {count} 个，请先吊销或等待旧码过期。': 'The unused activation code limit ({count}) has been reached. Revoke old codes or wait for them to expire.',
  '没有获取到系统声音。请在共享选择器中选择“整个屏幕”，并勾选“分享系统音频”。': 'No system audio was captured. Choose “Entire screen” and enable “Share system audio”.',
  '没有获取到标签页音频。请选择正在播放声音的 Chrome/Edge 标签页，并勾选“分享标签页音频”。': 'No tab audio was captured. Choose a Chrome/Edge tab playing audio and enable “Share tab audio”.',
  '电脑系统音频模式必须选择“整个屏幕”，不能选择标签页或窗口。': 'System audio mode requires “Entire screen”; a tab or window cannot be selected.',
  'Chrome 标签页模式必须选择一个浏览器标签页，不能选择整个屏幕。': 'Chrome tab mode requires selecting a browser tab, not the entire screen.',
  '保存中...': 'Saving...',
  '加入时间': 'Joined',
  '听众': 'Listener',
  '实时管理': 'Live management',
  '封禁': 'Ban',
  '已结束': 'Ended',
  '延迟': 'Latency',
  '开赛 2 小时后从听众端隐藏': 'Hidden from listeners 2 hours after kickoff',
  '当前没有听众在线。': 'No listeners are online.',
  '待展示': 'Visible',
  '恢复': 'Resume',
  '搜索或输入联赛，例如：英': 'Search or enter a league, e.g. Premier',
  '搜索或输入队名，例如：曼': 'Search or enter a team, e.g. Man',
  '搜索或输入队名，例如：阿': 'Search or enter a team, e.g. Arsenal',
  '暂停': 'Pause',
  '暂无赛程，请添加比赛时间和对阵。': 'No fixtures. Add match time and teams.',
  '本次登录尚未显示验证码明文。已生成的旧码仍按有效期有效，可在下方记录中吊销。': 'Plaintext codes are not shown after this login. Previously generated codes remain valid and can be revoked below.',
  '比赛安排': 'Fixture schedule',
  '添加中...': 'Adding...',
  '添加赛程': 'Add fixture',
  '状态': 'Status',
  '状态每 3 秒同步': 'Synced every 3 seconds',
  '管理': 'Actions',
  '联赛名称': 'League name',
  '赛事类型': 'Broadcast language',
  '外语播报': 'Foreign-language commentary',
  '中文播报': 'Chinese commentary',
  '踢出': 'Remove',  '付款超时封禁': 'Payment timeout ban',
  '设备封禁': 'Device ban',
  '错误': 'Error',
  '服务暂时不可用，请稍后重试。': 'The service is temporarily unavailable. Please try again later.',
};

const RU: Record<string, string> = {
  '免费活动': 'Бесплатная акция',
  '免费激活码活动': 'Акция с бесплатными кодами активации',
  '进行中': 'Активна',
  '未开始': 'Не началась',
  '已关闭': 'Отключена',
  '开始日期': 'Дата начала',
  '结束日期': 'Дата окончания',
  '保存活动时间': 'Сохранить даты акции',
  '关闭免费活动': 'Отключить бесплатную акцию',
  '开启免费活动': 'Включить бесплатную акцию',
  '免费活动时间已保存': 'Даты бесплатной акции сохранены',
  '免费活动已开启': 'Бесплатная акция включена',
  '免费活动已关闭': 'Бесплатная акция отключена',
  '开始日和结束日均按北京时间计算。每台设备每天可领取一次，不限制IP；关闭活动或日期不可用时隐藏领取入口，但已领取且未过期的免费码仍可使用。': 'Даты рассчитываются по пекинскому времени. Каждое устройство может получать код один раз в день без ограничения по IP. Когда акция недоступна, кнопка получения скрывается, но уже полученные действующие коды остаются доступными.',
  '活动时间：{range}': 'Период акции: {range}',
  '今日已领取，{time} 后可再次领取': 'Код уже получен сегодня. Следующий код можно получить через {time}.',
  '今日已领取，明天可再次领取': 'Код уже получен сегодня. Повторите завтра.',
  '活动尚未开始': 'Акция ещё не началась.',
  '免费活动当前不可用': 'Бесплатная акция сейчас недоступна.',
  '再领取一张 3 天激活码': 'Получить ещё один код на 3 дня',
  '免费领取 3 天激活码': 'Получить бесплатный код на 3 дня',
  '收费设置': 'Настройки оплаты',
  '激活码价格与收费模式': 'Цены кодов активации и платный режим',
  '收费模式已开启': 'Платный режим включён',
  '收费模式已关闭': 'Платный режим отключён',
  '日卡价格': 'Цена на 1 день',
  '周卡价格': 'Цена на 1 неделю',
  '月卡价格': 'Цена на 1 месяц',
  '保存价格': 'Сохранить цены',
  '关闭收费模式': 'Отключить платный режим',
  '开启收费模式': 'Включить платный режим',
  '激活码价格已保存': 'Цены кодов активации сохранены',
  '关闭收费模式后，听众端会隐藏付费购买区域，但已有订单仍可继续支付并自动发码；免费领取不受影响。价格仅支持 1–1,000,000 的整数 USDT，修改只影响新订单。': 'Когда платный режим отключён, область покупки скрывается, но существующие заказы можно оплатить и получить код автоматически. Бесплатное получение продолжает работать. Цена должна быть целым числом USDT от 1 до 1 000 000; изменения применяются только к новым заказам.',
  '足球播报语音室': 'Футбольная аудиокомната',
  '当前入口': 'Текущий раздел',
  '主控台': 'Панель владельца',
  '腾讯云 TRTC · 中国大陆': 'Tencent TRTC · Материковый Китай',
  '每个激活码最多绑定 3 台设备，同一时间仅限 1 台在线。': 'Один код активации поддерживает до 3 устройств, но одновременно только 1 устройство в сети.',
  '请截图保存激活码，遗失不补': 'Сохраните код активации. При утере он не восстанавливается.',
  '语言': 'Язык',
  '中文': 'Китайский',
  'English': 'Английский',
  'Русский': 'Русский',
  '正在检查管理服务...': 'Проверка сервиса управления...',
  '一次性初始化': 'Первичная настройка',
  '保存你的双重验证信息': 'Сохраните данные двухфакторной аутентификации',
  '下面的二维码和恢复码只显示这一次。恢复码建议打印或保存在密码管理器中。': 'QR-код и коды восстановления показываются только один раз. Распечатайте их или сохраните в менеджере паролей.',
  '恢复码': 'Коды восстановления',
  '我已安全保存，进入主控台': 'Я безопасно сохранил данные — открыть панель',
  '把电脑里的声音，安全地交给指定的人听。': 'Безопасно передавайте звук компьютера выбранным слушателям.',
  '浏览器直接共享系统声音。每张激活码最多绑定 3 台设备，同一时间只允许 1 台在线，有效期由主控设置。': 'Передавайте системный звук прямо из браузера. Один код активации поддерживает до 3 устройств, одновременно только 1 устройство в сети; срок задаёт владелец.',
  '系统声音': 'Системный звук',
  '三设备上限': 'До 3 устройств',
  '单设备在线': '1 устройство онлайн',
  '完整审计': 'Полный аудит',
  '主控登录': 'Вход владельца',
  '管理员身份验证': 'Аутентификация администратора',
  '管理员账号': 'Учётная запись администратора',
  '强密码': 'Надёжный пароль',
  '动态码或恢复码': 'Одноразовый код или код восстановления',
  '6 位动态码': '6-значный код',
  '验证中...': 'Проверка...',
  '登录主控台': 'Войти в панель владельца',
  '首次部署': 'Первое развёртывание',
  '创建唯一管理员': 'Создать единственного администратора',
  '系统尚未初始化。': 'Система ещё не инициализирована.',
  '开始初始化': 'Начать настройку',
  '部署引导令牌': 'Токен первичной настройки',
  '强密码（至少 12 位）': 'Надёжный пароль (не менее 12 символов)',
  '创建中...': 'Создание...',
  '创建管理员': 'Создать администратора',
  '共享控制中心': 'Центр управления трансляцией',
  '房间': 'Комната',
  '尚未开始': 'Не начато',
  '正在共享': 'Трансляция',
  '未共享': 'Нет трансляции',
  '刷新': 'Обновить',
  '退出登录': 'Выйти',
  '在线听众': 'Слушатели онлайн',
  '连接状态': 'Соединение',
  '本月参与者分钟': 'Минуты участников за месяц',
  '未使用激活码': 'Неиспользованные коды',
  '正在向听众发布': 'Передача слушателям',
  '准备共享电脑声音': 'Готово к передаче звука',
  '点击开始后，请在共享选择器中选择“整个屏幕”，并勾选“分享系统音频”。YY 语音、腾讯会议等软件声音会一起发送，其他系统声音也会包含在内。': 'После запуска выберите «Весь экран» и включите «Передавать системный звук». Звук YY, Tencent Meeting и другие системные звуки также будут переданы.',
  'EXE 中将打开网页版主控页面，请在外部浏览器中选择一个或多个 Chrome/Edge 标签页；电脑系统音频请在 EXE 中直接使用。': 'EXE откроет веб-панель владельца. Выберите одну или несколько вкладок Chrome/Edge во внешнем браузере; системный звук передавайте напрямую через EXE.',
  '点击开始后，请在共享选择器中选择一个正在播放声音的 Chrome/Edge 标签页，并勾选“分享标签页音频”。': 'После запуска выберите вкладку Chrome/Edge со звуком и включите «Передавать звук вкладки».',
  '共享音频来源': 'Источник звука',
  '电脑系统音频': 'Системный звук компьютера',
  '共享电脑全部播放声音，包含 YY 语音、腾讯会议等软件。': 'Передавать весь звук компьютера, включая YY, Tencent Meeting и другие приложения.',
  'Chrome 标签页音频': 'Звук вкладки Chrome',
  '只共享你在选择器中指定的 Chrome/Edge 标签页声音。': 'Передавать только звук выбранной вкладки Chrome/Edge.',
  '本窗口直播比赛': 'Матч для этого окна',
  '请选择比赛': 'Выберите матч',
  '当前浏览器不支持读取系统声音，请改用最新版 Chrome 或 Edge。': 'Этот браузер не поддерживает захват системного звука. Используйте последнюю версию Chrome или Edge.',
  '正在连接...': 'Подключение...',
  '开始共享': 'Начать трансляцию',
  '正在添加...': 'Добавление...',
  '添加另一个标签页直播': 'Добавить ещё одну трансляцию вкладки',
  '已启动 {count} 场标签页直播。': 'Запущено трансляций вкладок: {count}.',
  '停止全部共享': 'Остановить все трансляции',
  'Chrome 标签页直播': 'Трансляция вкладки Chrome',
  '标签页音频': 'Звук вкладки',
  '恢复中...': 'Восстановление...',
  '重新选择标签页': 'Выбрать вкладку заново',
  '停止本场': 'Остановить эту трансляцию',
  '等待开始': 'Ожидание запуска',
  '电脑系统与软件声音以 48 kHz 立体声发送': 'Системный звук и звук приложений передаётся в стерео 48 кГц',
  '所选 Chrome 标签页声音以 48 kHz 立体声发送': 'Звук выбранной вкладки Chrome передаётся в стерео 48 кГц',
  '可连续生成': 'Можно создать несколько',
  '生成 6 位激活码': 'Создать 6-значный код',
  '有效': 'Активен',
  '新激活码有效期': 'Срок нового кода',
  '正在生成...': 'Создание...',
  '生成激活码': 'Создать код активации',
  '生成后立即可用。': 'Доступен сразу после создания.',
  '可提前生成；主控开始共享后，听众才能进入。': 'Можно создать заранее; слушатели смогут войти после начала трансляции.',
  '每个码只允许首个设备使用，旧码不会被新码自动吊销。': 'Один код поддерживает до 3 устройств; новые коды не отменяют старые.',
  '请先选择比赛。': 'Сначала выберите матч.',
  '已在网页版打开主控页面。标签页独立直播请在外部浏览器中完成，请勿关闭浏览器窗口。': 'Веб-панель владельца открыта. Завершите трансляцию вкладок во внешнем браузере и не закрывайте окно.',
  '封禁原因': 'Причина блокировки',
  '管理员封禁': 'Заблокировано администратором',
  '请完整填写比赛时间、联赛、主队和客队': 'Заполните время матча, лигу и названия команд.',
  '确定删除这场赛程吗？': 'Удалить этот матч?',
  '购买订单与异常付款': 'Заказы и аномальные платежи',
  '暂无自助购买订单。': 'Нет заказов.',
  '异常到账 {count} 笔': 'Аномальных платежей: {count}',
  '激活码记录': 'Записи кодов',
  '激活码管理': 'Управление кодами',
  '有效激活码': 'Активные коды',
  '过期与吊销记录自动隐藏': 'Истёкшие и отозванные коды скрываются автоматически',
  '主控生成': 'Создано владельцем',
  '免费领取': 'Бесплатное получение',
  '搜索激活码、昵称或设备': 'Поиск кода, никнейма или устройства',
  '未显示': 'Не показан',
  '当前分组没有有效激活码。': 'В этой группе нет активных кодов.',
  '订单': 'Заказ',
  '复制': 'Копировать',
  '最近激活码': 'Последние коды',
  '尚未使用': 'Не использован',
  '设备': 'Устройства',
  '当前': 'Текущее',
  '剩余': 'Осталось',
  '吊销': 'Отозвать',
  '还没有生成激活码。': 'Коды ещё не создавались.',
  '费用保护': 'Защита расходов',
  '月度使用上限': 'Месячный лимит',
  '参与者分钟': 'Минуты участников',
  '保存': 'Сохранить',
  '默认 9,000 分钟，为腾讯云免费额度预留余量；设为 0 表示不限制。达到上限后新听众会被拒绝，已有听众不会被强制中断。': 'По умолчанию 9 000 минут; 0 — без ограничений. При достижении лимита новые слушатели не допускаются, текущие остаются.',
  '显示效果': 'Отображение',
  '虚拟在线人数': 'Виртуальное число онлайн',
  '基础人数': 'Базовое число',
  '虚拟在线人数已保存': 'Виртуальное число онлайн сохранено',
  '当前显示 {count} 人；保存后立即生效并保持到下一次 5–10 分钟更新；开播后按设定基数波动约 ±1；无直播且超过该窗口后恢复随机 5–10 人；真人加入或退出会同步 +1 / -1。该数字不影响真实听众上限。': 'Сейчас показано {count}. Сохранённое число сразу вступает в силу и сохраняется до следующего обновления через 5–10 минут. Во время трансляции оно меняется около базового значения на ±1. Если трансляции нет, после этого окна снова показывается случайное число 5–10. Реальные слушатели дают +1/−1. На лимит слушателей это не влияет.',
  '听众通知': 'Уведомление для слушателей',
  '滚动字幕': 'Бегущая строка',
  '输入要滚动显示的通知内容': 'Введите текст уведомления для прокрутки',
  '保存字幕': 'Сохранить сообщение',
  '清空': 'Очистить',
  '滚动字幕已保存': 'Бегущая строка сохранена',
  '滚动字幕已清空': 'Бегущая строка очищена',
  '听众端登录前和进入语音室后都会在赛程卡下方显示。留空并保存即可隐藏。': 'Отображается под карточкой расписания до входа и внутри голосовой комнаты. Чтобы скрыть, сохраните пустое сообщение.',
  '安全': 'Безопасность',
  '封禁设备': 'Заблокированные устройства',
  '隐藏审计日志': 'Скрыть журнал аудита',
  '查看审计日志': 'Показать журнал аудита',
  '解除封禁': 'Разблокировать',
  '当前没有封禁设备。': 'Заблокированных устройств нет.',
  '已连接': 'Подключено',
  '重连中': 'Переподключение',
  '未连接': 'Не подключено',
  '网络不稳定': 'Нестабильная сеть',
  '恢复中': 'Восстановление',
  '已暂停': 'Пауза',
  '等待授权': 'Ожидание разрешения',
  '音频已就绪': 'Звук готов',
  '授权失败': 'Ошибка разрешения',
  '1 天': '1 день',
  '1 周': '1 неделя',
  '1 个月': '1 месяц',
  '{seconds} 秒': '{seconds} сек.',
  '待支付': 'Ожидает оплаты',
  '已支付': 'Оплачено',
  '已过期': 'Истёк',
  '非指定 USDT': 'Неподдерживаемый USDT',
  '金额或订单不匹配': 'Сумма или заказ не совпадают',
  '不在付款时限': 'Вне окна оплаты',
  '交易已处理': 'Транзакция обработана',
  '已启用': 'Активирован',
  '已吊销': 'Отозван',
  '匹配': 'Совпадение',
  '常用': 'Часто',
  '复制失败，请手动复制。': 'Не удалось скопировать. Скопируйте вручную.',
  '自助购买': 'Покупка',
  '购买激活码': 'Купить код активации',  '限时福利': 'Ограниченное предложение',
  '免费领取激活码': 'Получить бесплатный код активации',
  '活动时间：9月1日–9月30日': 'Акция: 1–30 сентября',
  '免费领取 3 天激活码（9月1日–9月30日）': 'Получить бесплатный код на 3 дня (1–30 сентября)',
  '免费激活码已领取': 'Бесплатный код получен',
  '免费激活码领取成功': 'Бесплатный код успешно получен',
  '正在领取...': 'Получение...',
  '正在检查免费领取活动...': 'Проверка бесплатной акции...',
  '活动将于9月1日开始（9月1日–9月30日）': 'Акция начинается 1 сентября (1–30 сентября)',
  '免费领取已结束（9月1日–9月30日）': 'Бесплатная акция завершена (1–30 сентября)',
  '24小时内仅可领取一次（{time} 后可再次领取）': 'Достигнут лимит для этой сети; повторите через {time}.',
  '该设备已经领取过免费激活码，无法再次领取': 'Это устройство уже получило бесплатный код.',
  '该网络已领取过免费激活码，无法再次领取': 'С этой сети уже был получен бесплатный код активации.',
  '订单 {id}': 'Заказ {id}',
  '剩余 {time}': 'Осталось {time}',
  '订单已过期': 'Заказ истёк',
  '请精确支付': 'Оплатите точную сумму',
  '复制金额': 'Копировать сумму',
  '收款地址': 'Адрес получателя',
  '复制地址': 'Копировать адрес',
  '只通过 TRON 网络支付 TRC20 USDT，不要使用 ERC20、BEP20 或其他网络。金额必须完全一致，否则无法自动发码。': 'Оплачивайте только TRC20 USDT в сети TRON. Не используйте ERC20, BEP20 или другие сети. Сумма должна совпадать точно, иначе код не будет выдан автоматически.',
  '重新生成订单': 'Создать заказ заново',
  '支付已确认': 'Платёж подтверждён',
  '有效期至 {time}': 'Действует до {time}',
  '复制激活码': 'Копировать код',
  '填入并进入': 'Вставить и войти',
  '应付金额已复制': 'Сумма скопирована',
  '收款地址已复制': 'Адрес скопирован',
  '激活码已复制': 'Код скопирован',
  '听众入口': 'Вход для слушателя',
  '请输入你的六位激活码': 'Введите 6-значный код активации',
  '在线 {count} 人': 'Онлайн: {count}',
  '每张激活码最多绑定 3 台设备，同一时间仅限 1 台在线；关闭页面或主动退出后，可重新输入同一激活码继续收听。': 'Один код поддерживает до 3 устройств, но одновременно только 1 устройство в сети. После выхода можно снова ввести тот же код.',
  '你的昵称（必填）': 'Ваш никнейм (обязательно)',
  '例如：小王': 'Например: Алекс',
  '六位激活码': '6-значный код активации',
  '进入语音室': 'Войти в аудиокомнату',
  '正在进入语音室...': 'Вход в аудиокомнату...',
  '正在收听': 'Прослушивание',
  '等待音源接入中': 'Ожидание источника звука',
  '播放已暂停': 'Воспроизведение на паузе',
  '声音正在播放': 'Звук воспроизводится',
  '等待声音到来': 'Ожидание звука',
  '激活码剩余有效期': 'Остаток срока кода',
  '本机音量': 'Громкость',
  '播放设备': 'Устройство вывода',
  '默认播放设备': 'Устройство по умолчанию',
  '切换比赛': 'Переключить матч',
  '其他直播': 'Другая трансляция',
  '（当前收听）': ' (сейчас слушаете)',
  '正在切换...': 'Переключение...',
  '切换到此场': 'Переключиться на этот матч',
  '网络延迟': 'Задержка сети',
  '恢复窗口到': 'Окно восстановления до',
  '恢复播放': 'Продолжить',
  '暂停播放': 'Пауза',
  '退出语音室': 'Выйти из аудиокомнаты',
  '主控可以暂停播放、踢出或封禁设备。会话不会给予下载或录制权限。': 'Владелец может приостановить воспроизведение, удалить или заблокировать устройство. Сессия не даёт прав на скачивание или запись.',
  '暂无赛程': 'Матчей нет',
  '正在进行': 'Сейчас',
  '下一场': 'Следующий',
  '下一场直播': 'Следующая трансляция',
  '近期赛程': 'Ближайшие матчи',
  '等待中': 'Ожидание',
  '耐心等待，祝君好运！': 'Пожалуйста, подождите. Удачи!',
  '正在恢复上次收听...': 'Восстановление прошлой сессии...',
  '上次收听会话已结束。': 'Предыдущая сессия завершена.',
  '上次收听会话已失效，请重新进入。': 'Предыдущая сессия истекла. Войдите снова.',
  '已恢复收听。': 'Прослушивание восстановлено.',
  '控制服务网络不稳定，正在自动重试...': 'Сервис управления нестабилен. Автоматическая повторная попытка...',
  '激活码已过期，请重新购买或联系主控获取。': 'Код активации истёк. Купите новый или свяжитесь с владельцем.',
  '连接多次恢复失败，请重新取得激活码。': 'Не удалось восстановить соединение. Получите новый код активации.',
  '检测到临时中断，正在自动恢复...': 'Обнаружен временный сбой. Автоматическое восстановление...',
  '已自动恢复收听。': 'Прослушивание восстановлено автоматически.',
  '会话已结束，如需继续收听请向主控索取新的激活码。': 'Сессия завершена. Запросите новый код у владельца.',
  '音频连接波动，正在等待自动恢复...': 'Нестабильное аудиосоединение. Ожидание восстановления...',
  '你已被主控移出语音室。': 'Владелец удалил вас из аудиокомнаты.',
  '主控已暂停你的播放。': 'Владелец приостановил воспроизведение.',
  '主控已恢复播放。': 'Владелец возобновил воспроизведение.',
  '连接中断，正在恢复...': 'Соединение потеряно. Восстановление...',
  '连接已恢复。': 'Соединение восстановлено.',
  '请填写昵称后再进入': 'Введите никнейм.',
  '已进入语音室。若浏览器没有自动播放，请点击“恢复播放”。': 'Вы вошли в аудиокомнату. Если звук не запустился автоматически, нажмите «Продолжить».',
  '已在本机暂停播放。': 'Воспроизведение приостановлено на этом устройстве.',
  '已恢复播放。': 'Воспроизведение возобновлено.',
  '已切换到新的比赛。': 'Переключено на новый матч.',
  '切换失败，原房间也无法恢复，请重新进入语音室。': 'Переключение не удалось, исходная комната не восстановлена. Войдите снова.',
  '切换比赛失败：{message}': 'Ошибка переключения матча: {message}',
  '已退出语音室。': 'Вы вышли из аудиокомнаты.',
  '{days}天 {clock}': '{days} дн. {clock}',
  '{label}有效 · 发给一位听众': '{label} активен · Отправьте слушателю',
  '{time}后失效 · 最多 3 台设备': 'Истекает через {time} · До 3 устройств',
  '状态：{status}': 'Статус: {status}',
  '未使用激活码已达 {count} 个，请先吊销或等待旧码过期。': 'Достигнут лимит неиспользованных кодов ({count}). Отзовите старые коды или дождитесь их истечения.',
  '没有获取到系统声音。请在共享选择器中选择“整个屏幕”，并勾选“分享系统音频”。': 'Системный звук не получен. Выберите «Весь экран» и включите «Передавать системный звук».',
  '没有获取到标签页音频。请选择正在播放声音的 Chrome/Edge 标签页，并勾选“分享标签页音频”。': 'Звук вкладки не получен. Выберите вкладку Chrome/Edge со звуком и включите «Передавать звук вкладки».',
  '电脑系统音频模式必须选择“整个屏幕”，不能选择标签页或窗口。': 'Для режима системного звука выберите «Весь экран», а не вкладку или окно.',
  'Chrome 标签页模式必须选择一个浏览器标签页，不能选择整个屏幕。': 'Для режима вкладки Chrome выберите вкладку браузера, а не весь экран.',
  '保存中...': 'Сохранение...',
  '加入时间': 'Подключился',
  '听众': 'Слушатель',
  '实时管理': 'Управление в реальном времени',
  '封禁': 'Блокировать',
  '已结束': 'Завершён',
  '延迟': 'Задержка',
  '开赛 2 小时后从听众端隐藏': 'Скрывается у слушателей через 2 часа после начала',
  '当前没有听众在线。': 'Сейчас слушателей онлайн нет.',
  '待展示': 'Будет показан',
  '恢复': 'Продолжить',
  '搜索或输入联赛，例如：英': 'Найдите или введите лигу, например Premier',
  '搜索或输入队名，例如：曼': 'Найдите или введите команду, например Man',
  '搜索或输入队名，例如：阿': 'Найдите или введите команду, например Arsenal',
  '暂停': 'Пауза',
  '暂无赛程，请添加比赛时间和对阵。': 'Матчей нет. Добавьте время и команды.',
  '本次登录尚未显示验证码明文。已生成的旧码仍按有效期有效，可在下方记录中吊销。': 'После этого входа открытые коды не показываются. Ранее созданные коды действуют до срока и могут быть отозваны ниже.',
  '比赛安排': 'Расписание матчей',
  '添加中...': 'Добавление...',
  '添加赛程': 'Добавить матч',
  '状态': 'Статус',
  '状态每 3 秒同步': 'Синхронизация каждые 3 секунды',
  '管理': 'Действия',
  '联赛名称': 'Название лиги',
  '赛事类型': 'Язык комментария',
  '外语播报': 'Комментарий на иностранном языке',
  '中文播报': 'Комментарий на китайском языке',
  '踢出': 'Удалить',
  '赛程管理': 'Управление матчами',
  '比赛时间': 'Время матча',
  '主队': 'Хозяева',
  '客队': 'Гости',
  '保存修改': 'Сохранить изменения',
  '取消编辑': 'Отменить редактирование',
  '编辑': 'Изменить',
  '删除': 'Удалить',
  '付款超时封禁': 'Блокировка за неоплату',
  '设备封禁': 'Блокировка устройства',
  '错误': 'Ошибка',
  '服务暂时不可用，请稍后重试。': 'Сервис временно недоступен. Повторите позже.',
};

const ERROR_EN: Record<string, string> = {
  BAD_REQUEST: 'Invalid request.',
  UNAUTHORIZED: 'Authentication has expired. Please sign in again.',
  FORBIDDEN: 'You do not have permission for this action.',
  NOT_FOUND: 'The requested item was not found.',
  CONFLICT: 'The request conflicts with the current state.',
  INVITE_EXPIRED: 'The activation code has expired.',
  INVITE_USED: 'The activation code is invalid, used, or revoked.',
  DEVICE_BANNED: 'This device has been banned.',
  RATE_LIMITED: 'Too many attempts. Please try again later.',
  STREAM_OFFLINE: 'The audio source is offline.',
  SESSION_ENDED: 'The session has ended.',
  NICKNAME_TAKEN: 'This nickname is already used by another device.',
  PAYMENT_BANNED: 'This device or IP is banned from creating new orders.',
  PAYMENT_ORDER_DAILY_LIMIT: 'This device reached the daily order limit after two unpaid timeouts. Try again tomorrow.',
  PAID_MODE_DISABLED: 'Paid activation orders are currently disabled.',
  FREE_CLAIM_UNAVAILABLE: 'The free-claim promotion is not available.',
  FREE_CLAIM_COOLDOWN: 'This device has already claimed a free code today. Try again tomorrow.',
  INVITE_DEVICE_LIMIT: 'This activation code has reached the 3-device limit.',
  INVITE_DEVICE_ONLINE: 'This activation code is already online on another device. Exit there first.',
  LIMIT_REACHED: 'The current limit has been reached.',
  INTERNAL_ERROR: 'An internal error occurred.'
};

const ERROR_RU: Record<string, string> = {
  BAD_REQUEST: 'Некорректный запрос.',
  UNAUTHORIZED: 'Срок авторизации истёк. Войдите снова.',
  FORBIDDEN: 'Недостаточно прав.',
  NOT_FOUND: 'Запрошенный объект не найден.',
  CONFLICT: 'Запрос конфликтует с текущим состоянием.',
  INVITE_EXPIRED: 'Код активации истёк.',
  INVITE_USED: 'Код активации недействителен, использован или отозван.',
  DEVICE_BANNED: 'Это устройство заблокировано.',
  RATE_LIMITED: 'Слишком много попыток. Повторите позже.',
  STREAM_OFFLINE: 'Источник звука не в сети.',
  SESSION_ENDED: 'Сессия завершена.',
  NICKNAME_TAKEN: 'Этот никнейм уже используется другим устройством.',
  PAYMENT_BANNED: 'Это устройство или IP заблокированы для создания новых заказов.',
  PAYMENT_ORDER_DAILY_LIMIT: 'На этом устройстве достигнут дневной лимит заказов. Попробуйте завтра.',
  PAID_MODE_DISABLED: 'Создание платных заказов сейчас отключено.',
  FREE_CLAIM_UNAVAILABLE: 'Бесплатная акция сейчас недоступна.',
  FREE_CLAIM_COOLDOWN: 'Это устройство уже получило бесплатный код сегодня. Повторите завтра.',
  INVITE_DEVICE_LIMIT: 'Достигнут лимит в 3 устройства для этого кода.',
  INVITE_DEVICE_ONLINE: 'Этот код уже используется на другом устройстве. Сначала выйдите там.',
  LIMIT_REACHED: 'Достигнут текущий лимит.',
  INTERNAL_ERROR: 'Внутренняя ошибка.'
};

let currentLanguage: Language = detectLanguage();

function detectLanguage(): Language {
  if (typeof window === 'undefined') return 'zh';
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === 'zh' || saved === 'en' || saved === 'ru') return saved;
  const browser = window.navigator.language.toLowerCase();
  if (browser.startsWith('ru')) return 'ru';
  if (browser.startsWith('zh')) return 'zh';
  return 'en';
}

export function getLanguage(): Language {
  return currentLanguage;
}

export function getLanguageTimeZone(language: Language = currentLanguage): string {
  if (language === 'zh') return 'Asia/Shanghai';
  if (language === 'ru') return 'Europe/Moscow';
  return 'UTC';
}
export function setLanguage(language: Language): void {
  currentLanguage = language;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language === 'zh' ? 'zh-CN' : language;
    window.dispatchEvent(new Event('ai-voice-language-change'));
  }
}

export function translate(language: Language, source: string, params?: Record<string, string | number>): string {
  const template = language === 'zh' ? source : (language === 'en' ? EN[source] : RU[source]) ?? source;
  if (!params) return template;
  return Object.entries(params).reduce(
    (text, [key, value]) => text.replaceAll(`{${key}}`, String(value)),
    template
  );
}

export function t(source: string, params?: Record<string, string | number>): string {
  return translate(currentLanguage, source, params);
}

export function tError(code: string | undefined, fallback: string): string {
  if (currentLanguage === 'zh' || !code) return fallback;
  const table = currentLanguage === 'en' ? ERROR_EN : ERROR_RU;
  return table[code] ?? fallback;
}
